export default __webpack_public_path__ + "static/media/topleft.0149da68.png";